import { createQuery } from '../../utils';
import { FundingOpportunityList } from '@hum/types';
import { parseFundingOpportunityList } from './parseFundingOpportunityList';

export const getFundingOpportunities = createQuery<FundingOpportunityList>(
  ({ api, session, router }) => {
    const companyId = router.query.company_id || session.user?.organizationId;

    return api
      .get(`/v2/companies/${companyId}/funding_opportunities`)
      .then((res) => parseFundingOpportunityList(res.items || []));
  },
  {
    errorToast: { message: 'Failed to fetch funding opportunities' },
  }
);
